"use client";
import { useEffect, useRef, useState } from 'react';
import { LogOut, UserRound, AtSign, Building2, Sun, Monitor, Moon, ChevronRight, ChevronLeft, FileText, HelpCircle } from 'lucide-react';
import { useUser } from '@/app/context/UserContext';
import { signOutFirebase } from '@/app/helpers/firebase';

const themes = [
  { id: "system", icon: <Monitor className="w-4 h-4" strokeWidth={0.8}/>, label: "Sistema" },
  { id: "light", icon: <Sun className="w-4 h-4" strokeWidth={0.8} />, label: "Claro" },
  { id: "dark", icon: <Moon className="w-4 h-4" strokeWidth={0.8} />, label: "Oscuro" },
];


const DropdownUser = ({ isOpen, onOpen, onClose, dropdownRef}: { isOpen: boolean; onOpen: () => void; onClose: () => void; dropdownRef : any }) => {
    const { user, setUser, userProject,setUserProject, myDocs, setMyDocs,
    } = useUser();// Accedemos al usuario logueado desde el contexto
    const [selectedTheme, setSelectedTheme] = useState("system");

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) 
        ) {
            onClose(); 
        }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        if(user.isAnonymous){
          setUser( null ); 
          setUserProject( null ); 
        } else{
          await signOutFirebase();
          setUser( null ); 
          setUserProject( null ); 
          if(myDocs){ 
            const updatedDocs = myDocs.map((doc) => ({
              ...doc,
              seleccionado: false,
            })); 
            setMyDocs(updatedDocs);
          }  
        }
        
      };

  return (
    <div className="relative" >
      
      {isOpen && (
        <div 
                className={`absolute right-0 top-6  w-64 bg-white shadow-lg n-menu-content-user overflow-hidden z-50 
                    transition-all duration-700 ease-in-out transform 
                    ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-90'} 
                    ${ !isOpen ? 'pointer-events-none' : ''} 
                    animate-fadeIn` }
            >
              
        {user.isAnonymous ? 
            <div className="flex flex-col p-4 space-y-2 n-list-user">
                <button 
                    className="flex items-center space-x-2 hover:bg-gray-100 p-3 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-700"
                    onClick={handleLogout}
                    type="button"
                    >
                  <LogOut strokeWidth={0.8} className="w-4 h-4 text-gray-600" />
                  <span>Iniciar sesión</span>
                </button>
              </div>
           :
            <> 
                <div className="flex flex-col p-4 border-b">
                    <div className="flex items-center space-x-2 pt-2  n-list-user">
                        <UserRound strokeWidth={0.8} className="w-4 h-4 text-gray-600" />
                        <span>{user.displayName}</span>
                    </div>
                    <div className="flex items-center space-x-2 pt-2 text-sm">
                        <AtSign strokeWidth={0.8} className="w-4 h-4 text-gray-600" />
                        <span>{user.email}</span>
                    </div> 
              </div>
     
              <div className="p-4 border-b flex items-center space-x-2 n-list-user">
                <Building2 strokeWidth={0.8} className="w-4 h-4 text-gray-600"  />
                <span>{ userProject?.project?.domain || ""}</span>
              </div>
                
                  
                {/*}
                  <div className="pl-2 items-center space-x-2 bg-gray-100 p-1 rounded-full w-32">
                    {themes.map((theme) => (
                      <button
                        key={theme.id}
                        onClick={() => setSelectedTheme(theme.id)}
                        className={`p-2 rounded-full transition-colors ${
                          selectedTheme === theme.id ? "bg-gray-200 shadow-md" : "hover:bg-gray-300"
                        }`}
                      >
                        {theme.icon}
                      </button>
                    ))}
                  </div>
                */}
                <div className="flex flex-col p-4 space-y-2 n-list-user">
                {/*<button className="flex items-center space-x-2 hover:bg-gray-100 p-2 rounded">
                  <FileText className="w-5 h-5 text-gray-600" />
                  <span>Mi Perfil</span>
                </button>
                <button className="flex items-center space-x-2 hover:bg-gray-100 p-2 rounded">
                  <HelpCircle className="w-5 h-5 text-gray-600" />
                  <span>Ayuda</span>
                </button>*/}
                <button 
                    className="flex items-center space-x-2 hover:bg-gray-100 p-3 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-700"
                    onClick={handleLogout}
                    >
                  <LogOut strokeWidth={0.8} className="w-4 h-4 text-gray-600" />
                  <span>Cerrar sesión</span>
                </button>
              </div> 
            </> 
          } 
        </div>
      )}
    </div>
  );
};

export default DropdownUser;


